/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { isRouteForCreationMode, UserContext } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { JobDppDetails, JobDppDetailsGeneral } from '../../resources/job.model';
import { JobDppGeneralTabFormState } from './job-dpp-details-general-tab/job-dpp-details-general-tab-form.service';

@Injectable()
export class JobDppDetailsFormState extends FormState<JobDppDetails> {

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private generalForm: JobDppGeneralTabFormState,
              private route: ActivatedRoute,
              private userContext: UserContext) {
    super(schemaFactory);
  }

  build(general: JobDppDetailsGeneral): void {
    const mode = isRouteForCreationMode(this.route) ? FormMode.CreateMode :
      (this.userContext.hasPermission(BuilderPermission.JobAdmin.JobDetails.EDIT) && !general.isNotProceeding
        ? FormMode.EditMode : FormMode.ViewMode);
    this.setMode(mode);

    this.generalForm.build(general);

    this.initSchema({ id: general.id, general });

    this.setChildForm('general', this.generalForm);
  }

  protected buildSchema(value: JobDppDetails, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      optimisticLock: true,
      children: {
        id: void 0,
        general: native(this.generalForm.group),
      },
    });
  }
}
